export const FETCH_ANSWER_RULES_REQUEST = "FETCH_ANSWER_RULES_REQUEST";
export const FETCH_ANSWER_RULES_SUCCESS = "FETCH_ANSWER_RULES_SUCCESS";
export const FETCH_ANSWER_RULES_FAIL = "FETCH_ANSWER_RULES_FAIL";
export const UPDATE_ANSWER_RULE_REQUEST = "UPDATE_ANSWER_RULE_REQUEST";
export const UPDATE_ANSWER_RULE_SUCCESS = "UPDATE_ANSWER_RULE_SUCCESS";
export const UPDATE_ANSWER_RULE_FAIL = "UPDATE_ANSWER_RULE_FAIL";
export const FETCH_ANSWER_RULE_REQUEST = "FETCH_ANSWER_RULE_REQUEST";
export const FETCH_ANSWER_RULE_SUCCESS = "FETCH_ANSWER_RULE_SUCCESS";
export const FETCH_ANSWER_RULE_FAIL = "FETCH_ANSWER_RULE_FAIL";
